
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between">
     
        <div className="flex flex-col space-y-2 text-center justify-center items-center w-full">
        <Link to="/home" className="hover:underline">Home</Link>
          <Link to="/contact" className="hover:underline">Contact</Link>
          <Link to="/about" className="hover:underline">About Us</Link>
          <Link to="/terms" className="hover:underline">Terms of Service</Link>
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
        </div>
      </div>
      <div className="text-center mt-8">
        © 2024 ShreeJewels. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
